import { ReactNode } from "react";
import styles from "./styles/Tab.module.css";
import cn from "classnames";

// Height   24  | 32  | 40 (px)
type Size = "S" | "M" | "L";

/*
 * Size is required instead of having a default.
 * This makes it easier to refactor the prop names and values.
 *
 * It also means you don't have to check what the defaults are to figure
 * out what size a specific tab has, since they will always be
 * specified.
 */

interface Props {
  size: Size;
  children: ReactNode;
  className?: string;
  fillWidth?: boolean;
  marginBottom?: boolean;
}

export const TabList: React.FC<Props> = (props) => {
  const { size, fillWidth = false, marginBottom = true } = props;

  return (
    <div
      className={cn(
        styles.tabsList,
        styles[`size-${size}`],
        fillWidth && styles.fillWidth,
        marginBottom && styles.marginBottom,
        props.className
      )}
    >
      {props.children}
    </div>
  );
};
